// ExperiencePage.js
import React from 'react';

const ExperiencePage = () => {
  return (
    <div>
      <div style={{ margin: '20px 0' }}>
        <h3>Backend Developer & Data Engineer</h3>
        <p><strong>Current Focus:</strong> Building robust data pipelines and internal tooling</p>
        <ul style={{ paddingLeft: '20px', margin: '10px 0' }}>
          <li>Designed and implemented ETL/ELT pipelines using Apache Airflow</li>
          <li>Built automated workflows that reduced manual processing time by 80%</li>
          <li>Developed internal APIs for data access and team productivity tools</li>
          <li>Managed cloud infrastructure on AWS and GCP</li>
        </ul>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Key Projects</h3>
        <p><strong>Data Pipeline Automation:</strong> Streamlined data ingestion processes with automated monitoring and error handling</p>
        <p><strong>Internal Tooling:</strong> Created developer productivity tools that improved team efficiency and reduced deployment time</p>
        <p><strong>Infrastructure as Code:</strong> Implemented Terraform configurations for consistent, repeatable deployments</p>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Technical Achievements</h3>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Reduced data processing latency by 60% through pipeline optimization</li>
          <li>Implemented comprehensive monitoring and alerting systems</li>
          <li>Established CI/CD practices that improved deployment reliability</li>
          <li>Mentored team members on best practices for data engineering</li>
        </ul>
      </div>

      <p><em>Professional experience showcasing my development journey and achievements in backend development, data engineering, and DevOps practices.</em></p>
    </div>
  );
};

export default ExperiencePage;